/**
 * Card Type Detector — Standalone Version
 * 
 * Detects card brand from number, formats card/expiry inputs,
 * validates expiry dates, and runs Luhn checks.
 * 
 * Zero external dependencies.
 */

export const CARD_TYPES = {
  visa: {
    name: 'Visa',
    pattern: /^4/,
    maxLength: 16,
    cvvLength: 3
  },
  mastercard: {
    name: 'Mastercard',
    pattern: /^5[1-5]|^2[2-7]/,
    maxLength: 16,
    cvvLength: 3
  },
  amex: {
    name: 'American Express',
    pattern: /^3[47]/,
    maxLength: 15,
    cvvLength: 4
  },
  discover: {
    name: 'Discover',
    pattern: /^6(?:011|5)/,
    maxLength: 16,
    cvvLength: 3
  },
  mir: {
    name: 'MIR',
    pattern: /^220[0-4]/,
    maxLength: 16,
    cvvLength: 3
  }
};

export function detectCardType(number) {
  if (!number) return null;
  const clean = number.replace(/\s/g, '');
  for (const [key, config] of Object.entries(CARD_TYPES)) {
    if (config.pattern.test(clean)) return key;
  }
  return null;
}

export function formatCardNumber(value) {
  const clean = value.replace(/\D/g, '').slice(0, 16);
  const groups = clean.match(/.{1,4}/g);
  return groups ? groups.join(' ') : '';
}

export function formatExpiry(value) {
  const clean = value.replace(/\D/g, '').slice(0, 4);
  if (clean.length >= 3) {
    return clean.slice(0, 2) + '/' + clean.slice(2);
  }
  return clean;
}

export function isValidExpiry(value) {
  const match = value.match(/^(\d{2})\/(\d{2})$/);
  if (!match) return false;
  const month = parseInt(match[1], 10);
  const year = parseInt('20' + match[2], 10);
  if (month < 1 || month > 12) return false;
  const now = new Date();
  const expDate = new Date(year, month);
  return expDate > now;
}

export function luhnCheck(number) {
  const clean = number.replace(/\s/g, '');
  let sum = 0;
  let isEven = false;
  for (let i = clean.length - 1; i >= 0; i--) {
    let digit = parseInt(clean[i], 10);
    if (isEven) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    isEven = !isEven;
  }
  return sum % 10 === 0;
}
